import styled from 'styled-components';

const ContentStyles = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 2.4rem;
`;

export default ContentStyles;
